export default __webpack_public_path__ + "static/media/barra.b376a523.png";